{
  "groups": {
    "dashboard": "Overview",
    "work": "Work",
    "administration": "Administration",
    "people": "People",
    "time-attendance": "Time & attendance",
    "payroll": "Payroll",
    "reports": "Reports",
    "setup": "Setup & configuration",
    "operations": "Operations",
    "expenses": "Expenses & travel",
    "talent": "Talent & performance",
    "portals": "Self-service portals",
    "settings": "Settings"
  },
  "paths": {
    "hr": "HR dashboard",
    "hr.attendance": "Attendance and leave",
    "hr.timesheet": "Timesheet",
    "hr.payroll": "Payroll runs",
    "hr.dashboard": "HR Dashboard",
    "hr.leaves": "Leaves",
    "hr.ess": "Ess",
    "hr.mss": "Mss",
    "hr.setup": "Setup",
    "hr.master-data": "Master Data",
    "org.companies": "Companies",
    "work.approvals": "Approval inbox",
    "pos.dashboard": "Dashboard",
    "pos.stores": "Stores",
    "pos.products": "Products",
    "pos.categories": "Categories",
    "pos.brands": "Brands",
    "pos.units": "Units",
    "pos.tax-rules": "Tax Rules",
    "pos.store-products": "Store Products",
    "pos.invoices": "Invoices",
    "pos.inventory": "Inventory",
    "pos.inventory.ledger": "Ledger",
    "pos.product-alerts": "Product Alerts",
    "pos.suppliers": "Suppliers",
    "pos.customers": "Customers",
    "pos.discounts": "Discounts",
    "pos.reports": "Reports",
    "pos.terminal-reports": "Terminal Reports",
    "pos": "Pos",
    "pos.held": "Held",
    "pos.shift": "Shift",
    "pos.returns": "Returns",
    "pos.analytics": "Analytics",
    "pos.setup": "Setup",
    "warehouse": "Warehouse",
    "warehouse.operations": "Operations",
    "warehouse.mobile": "Mobile",
    "warehouse.setup": "Setup",
    "warehouse.picks": "Picks",
    "warehouse.transfers": "Transfers",
    "warehouse.cycle-counts": "Cycle Counts",
    "warehouse.waves": "Waves",
    "warehouse.dock": "Dock",
    "warehouse.cross-dock": "Cross Dock",
    "warehouse.labor": "Labor",
    "procurement": "Procurement",
    "procurement.purchase-requests": "Purchase Requests",
    "procurement.rfqs": "Rfqs",
    "procurement.quotations": "Quotations",
    "procurement.purchase-orders": "Purchase Orders",
    "procurement.goods-receipts": "Goods Receipts",
    "procurement.vendor-bills": "Vendor Bills",
    "procurement.approvals": "Approvals",
    "procurement.reports": "Reports",
    "procurement.setup": "Setup",
    "procurement.contracts": "Contracts",
    "procurement.catalogs": "Catalogs",
    "crm": "Crm",
    "crm.leads": "Leads",
    "crm.contacts": "Contacts",
    "crm.companies": "Companies",
    "crm.deals": "Deals",
    "crm.pipelines": "Pipelines",
    "crm.followups": "Followups",
    "crm.tasks": "Tasks",
    "crm.campaigns": "Campaigns",
    "crm.analytics": "Analytics",
    "crm.reports": "Reports",
    "crm.setup": "Setup",
    "lead-gen": "Lead Generation",
    "lead-gen.forms": "Forms",
    "lead-gen.landing-pages": "Landing Pages",
    "lead-gen.campaigns": "Campaigns",
    "lead-gen.visitor-tracking": "Visitor Tracking",
    "lead-gen.scoring": "Scoring",
    "lead-gen.routing": "Routing",
    "lead-gen.ab-tests": "Ab Tests",
    "lead-gen.webhooks": "Webhooks",
    "lead-gen.enrichment": "Enrichment",
    "lead-gen.consent": "Consent",
    "lead-gen.reports": "Reports",
    "lead-gen.sources": "Sources",
    "marketing": "Marketing",
    "marketing.campaigns": "Campaigns",
    "marketing.segments": "Segments",
    "marketing.journeys": "Journeys",
    "marketing.templates": "Templates",
    "marketing.lifecycle": "Lifecycle",
    "marketing.reports": "Reports",
    "marketing.webhooks": "Webhooks",
    "social": "Social",
    "social.inbox": "Inbox",
    "social.channels": "Channels",
    "social.publishing": "Publishing",
    "social.calendar": "Calendar",
    "social.media": "Media",
    "social.analytics": "Analytics",
    "social.automation": "Automation",
    "social.crm-leads": "Crm Leads",
    "social.teams": "Teams",
    "social.comments": "Comments",
    "social.connect": "Connect",
    "social.settings": "Settings",
    "social.platforms": "Platforms",
    "social.approvals": "Approvals",
    "social.webhooks": "Webhooks",
    "social.listening": "Listening",
    "social.campaigns": "Campaigns",
    "social.reviews": "Reviews",
    "social.reports": "Reports",
    "social.setup": "Setup",
    "hr.employees": "Employee directory",
    "hr.devices": "Biometric devices",
    "hr.leave-policies": "Leave Policies",
    "hr.shifts": "Shift",
    "hr.overtime": "Overtime requests",
    "hr.compensation": "Salary & benefits",
    "hr.statutory": "Statutory filing",
    "hr.claims": "Expense claims",
    "hr.travel": "Travel requests",
    "hr.reports": "HR analytics & dashboards",
    "hr.workflows": "Workflows",
    "hr.recruitment": "Recruitment",
    "hr.onboarding": "Onboarding",
    "hr.documents": "Documents",
    "hr.succession": "Succession",
    "hr.admin": "Admin",
    "hr.training": "Training",
    "hr.appraisal": "Appraisal",
    "hr.feedback360": "Feedback360",
    "hr.holidays": "Holidays",
    "hr.loans": "Loans",
    "hr.asset-requests": "Asset Requests",
    "desk": "Desk",
    "desk.tickets": "Tickets",
    "desk.support-360": "Support 360",
    "desk.inbox": "Inbox",
    "desk.livechat": "Livechat",
    "desk.projects": "Projects",
    "desk.boards": "Boards",
    "desk.knowledgebase": "Knowledgebase",
    "desk.reports": "Reports",
    "desk.automation": "Automation",
    "desk.setup": "Setup",
    "desk.setup.workflows": "Workflows",
    "desk.canned-responses": "Canned Responses",
    "finance": "Finance",
    "finance.receivables": "Receivables",
    "finance.payables": "Payables",
    "finance.payables.ap": "Ap",
    "finance.tax": "Tax",
    "finance.control": "Control",
    "finance.setup.wizard": "Wizard",
    "finance.health": "Health",
    "finance.close": "Close",
    "finance.control.rules": "Rules",
    "finance.treasury.forecast": "Forecast",
    "finance.collections": "Collections",
    "finance.automation": "Automation",
    "finance.analytics": "Analytics",
    "finance.compliance": "Compliance",
    "finance.audit": "Audit",
    "finance.documents": "Documents",
    "finance.integrations": "Integrations",
    "finance.accounting": "Accounting",
    "finance.ledger": "Ledger",
    "finance.invoices": "Invoices",
    "finance.payments": "Payments",
    "finance.banking": "Banking",
    "finance.taxes": "Taxes",
    "finance.expenses": "Expenses",
    "finance.assets": "Assets",
    "finance.budgets": "Budgets",
    "finance.treasury": "Treasury",
    "finance.revenue": "Revenue",
    "finance.workflows": "Workflows",
    "finance.workflows.designer": "Designer",
    "finance.reports": "Reports",
    "finance.reports.builder": "Builder",
    "finance.setup": "Setup",
    "projects": "Projects",
    "projects.list": "List",
    "projects.tasks": "Tasks",
    "projects.boards": "Boards",
    "projects.sprints": "Sprints",
    "projects.timesheets": "Timesheets",
    "projects.portfolio": "Portfolio",
    "projects.issues": "Issues",
    "projects.gantt": "Gantt",
    "projects.resources": "Resources",
    "projects.calendar": "Calendar",
    "projects.workload": "Workload",
    "projects.reports": "Reports",
    "projects.automation": "Automation",
    "projects.setup": "Setup",
    "hr.org": "Reporting hierarchy",
    "pos.administration": "Administration",
    "pos.profile": "Profile",
    "pos.organization": "Organization",
    "pos.companies": "Companies",
    "pos.users": "Users",
    "pos.roles": "Roles",
    "pos.subscription": "Subscription",
    "pos.settings": "Settings",
    "pos.work": "Work",
    "pos.work.executive": "Executive",
    "pos.approvals": "Approvals",
    "pos.approvals.builder": "Builder",
    "pos.approvals.matrix": "Matrix",
    "pos.approvals.delegations": "Delegations",
    "pos.notifications": "Notifications",
    "crm.administration": "Administration",
    "crm.profile": "Profile",
    "crm.organization": "Organization",
    "crm.users": "Users",
    "crm.roles": "Roles",
    "crm.subscription": "Subscription",
    "crm.settings": "Settings",
    "crm.work": "Work",
    "crm.work.executive": "Executive",
    "crm.approvals": "Approvals",
    "crm.approvals.builder": "Builder",
    "crm.approvals.matrix": "Matrix",
    "crm.approvals.delegations": "Delegations",
    "crm.notifications": "Notifications",
    "hr.administration": "Administration",
    "hr.profile": "Profile",
    "hr.organization": "Organization",
    "hr.companies": "Companies",
    "hr.users": "Users",
    "hr.roles": "Roles",
    "hr.subscription": "Subscription",
    "hr.settings": "Settings",
    "hr.work": "Work",
    "hr.work.executive": "Executive",
    "hr.approvals": "Approvals",
    "hr.approvals.builder": "Builder",
    "hr.approvals.matrix": "Matrix",
    "hr.approvals.delegations": "Delegations",
    "hr.notifications": "Notifications",
    "desk.administration": "Administration",
    "desk.profile": "Profile",
    "desk.organization": "Organization",
    "desk.companies": "Companies",
    "desk.users": "Users",
    "desk.roles": "Roles",
    "desk.subscription": "Subscription",
    "desk.settings": "Settings",
    "desk.work": "Work",
    "desk.work.executive": "Executive",
    "desk.approvals": "Approvals",
    "desk.approvals.builder": "Builder",
    "desk.approvals.matrix": "Matrix",
    "desk.approvals.delegations": "Delegations",
    "desk.notifications": "Notifications",
    "finance.administration": "Administration",
    "finance.profile": "Profile",
    "finance.organization": "Organization",
    "finance.companies": "Companies",
    "finance.users": "Users",
    "finance.roles": "Roles",
    "finance.subscription": "Subscription",
    "finance.settings": "Settings",
    "finance.work": "Work",
    "finance.work.executive": "Executive",
    "finance.approvals": "Approvals",
    "finance.approvals.builder": "Builder",
    "finance.approvals.matrix": "Matrix",
    "finance.approvals.delegations": "Delegations",
    "finance.notifications": "Notifications",
    "projects.administration": "Administration",
    "projects.profile": "Profile",
    "projects.organization": "Organization",
    "projects.companies": "Companies",
    "projects.users": "Users",
    "projects.roles": "Roles",
    "projects.subscription": "Subscription",
    "projects.settings": "Settings",
    "projects.work": "Work",
    "projects.work.executive": "Executive",
    "projects.approvals": "Approvals",
    "projects.approvals.builder": "Builder",
    "projects.approvals.matrix": "Matrix",
    "projects.approvals.delegations": "Delegations",
    "projects.notifications": "Notifications",
    "procurement.administration": "Administration",
    "procurement.profile": "Profile",
    "procurement.organization": "Organization",
    "procurement.companies": "Companies",
    "procurement.users": "Users",
    "procurement.roles": "Roles",
    "procurement.subscription": "Subscription",
    "procurement.settings": "Settings",
    "procurement.work": "Work",
    "procurement.work.executive": "Executive",
    "procurement.approvals.builder": "Builder",
    "procurement.approvals.matrix": "Matrix",
    "procurement.approvals.delegations": "Delegations",
    "procurement.notifications": "Notifications",
    "warehouse.administration": "Administration",
    "warehouse.profile": "Profile",
    "warehouse.organization": "Organization",
    "warehouse.companies": "Companies",
    "warehouse.users": "Users",
    "warehouse.roles": "Roles",
    "warehouse.subscription": "Subscription",
    "warehouse.settings": "Settings",
    "warehouse.work": "Work",
    "warehouse.work.executive": "Executive",
    "warehouse.approvals": "Approvals",
    "warehouse.approvals.builder": "Builder",
    "warehouse.approvals.matrix": "Matrix",
    "warehouse.approvals.delegations": "Delegations",
    "warehouse.notifications": "Notifications",
    "social.administration": "Administration",
    "social.profile": "Profile",
    "social.organization": "Organization",
    "social.companies": "Companies",
    "social.users": "Users",
    "social.roles": "Roles",
    "social.subscription": "Subscription",
    "social.work": "Work",
    "social.work.executive": "Executive",
    "social.approvals.builder": "Builder",
    "social.approvals.matrix": "Matrix",
    "social.approvals.delegations": "Delegations",
    "social.notifications": "Notifications",
    "lead-gen.administration": "Administration",
    "lead-gen.profile": "Profile",
    "lead-gen.organization": "Organization",
    "lead-gen.companies": "Companies",
    "lead-gen.users": "Users",
    "lead-gen.roles": "Roles",
    "lead-gen.subscription": "Subscription",
    "lead-gen.settings": "Settings",
    "lead-gen.work": "Work",
    "lead-gen.work.executive": "Executive",
    "lead-gen.approvals": "Approvals",
    "lead-gen.approvals.builder": "Builder",
    "lead-gen.approvals.matrix": "Matrix",
    "lead-gen.approvals.delegations": "Delegations",
    "lead-gen.notifications": "Notifications",
    "marketing.administration": "Administration",
    "marketing.profile": "Profile",
    "marketing.organization": "Organization",
    "marketing.companies": "Companies",
    "marketing.users": "Users",
    "marketing.roles": "Roles",
    "marketing.subscription": "Subscription",
    "marketing.settings": "Settings",
    "marketing.work": "Work",
    "marketing.work.executive": "Executive",
    "marketing.approvals": "Approvals",
    "marketing.approvals.builder": "Builder",
    "marketing.approvals.matrix": "Matrix",
    "marketing.approvals.delegations": "Delegations",
    "marketing.notifications": "Notifications",
    "desk.customers": "Customers",
    "marketing.customers": "Customers",
    "projects.customers": "Customers",
    "lead-gen.customers": "Customers",
    "crm.customers": "Customers",
    "procurement.suppliers": "Suppliers",
    "procurement.products": "Products",
    "procurement.inventory": "Inventory",
    "procurement.inventory.ledger": "Ledger",
    "settings": "Settings",
    "settings.organization": "Organization",
    "settings.organization.organization-profile": "Organization Profile",
    "settings.organization.companies": "Companies",
    "settings.organization.users": "Users",
    "settings.organization.roles": "Roles & Screen Access",
    "settings.organization.subscription": "Subscription",
    "settings.organization.stores": "Stores",
    "settings.organization.translations": "Translations",
    "marketing.channels": "Channels",
    "marketing.calendar": "Calendar",
    "marketing.acquisition": "Acquisition",
    "marketing.media": "Media",
    "marketing.copilot": "Copilot",
    "marketing.suppression": "Suppression",
    "social.messenger": "Messenger",
    "social.workflows": "Workflows",
    "social.connect.add": "Add",
    "social.setup-guide": "Setup Guide",
    "social.executive": "Executive",
    "social.platforms.facebook": "Facebook",
    "social.platforms.instagram": "Instagram",
    "social.platforms.whatsapp": "Whatsapp",
    "social.platforms.linkedin": "Linkedin",
    "social.platforms.x": "X",
    "social.platforms.youtube": "Youtube",
    "social.platforms.google_business": "Google_business",
    "social.platforms.telegram": "Telegram",
    "social.platforms.threads": "Threads",
    "social.platforms.pinterest": "Pinterest",
    "social.platforms.tiktok": "Tiktok",
    "projects.:id": ":id",
    "pos.employees": "Employees",
    "crm.employees": "Employees",
    "desk.employees": "Employees",
    "finance.employees": "Employees",
    "projects.employees": "Employees",
    "procurement.employees": "Employees",
    "warehouse.employees": "Employees",
    "social.employees": "Employees",
    "lead-gen.employees": "Employees",
    "marketing.employees": "Employees",
    "settings.hr-master-data": "HR Master Data",
    "settings.hr": "Human Resources",
    "settings.finance": "Finance",
    "settings.inventory": "Inventory & POS",
    "settings.crm": "Sales & CRM",
    "settings.marketing": "Marketing",
    "settings.projects": "Projects",
    "settings.help-desk": "Help Desk",
    "settings.communication": "Communication",
    "settings.workflow": "Workflow",
    "settings.approvals": "Approvals",
    "settings.notifications": "Notifications",
    "settings.developer": "Developer",
    "settings.hr.hr-setup": "HR Setup",
    "settings.hr.org-structure": "Reporting Hierarchy",
    "settings.hr.hr-admin": "HR Administration",
    "settings.finance.finance-control": "Administration Home",
    "settings.finance.health-center": "Health Center",
    "settings.finance.period-close": "Period Close",
    "settings.finance.automation-center": "Automation Center",
    "settings.finance.integration-health": "Integration Health",
    "settings.finance.accounting-advanced": "Accounting (Advanced)",
    "settings.finance.finance-setup": "Finance Setup",
    "settings.finance.taxes": "Tax Codes",
    "settings.finance.business-rules": "Business Rules",
    "settings.finance.ledger": "General Ledger",
    "settings.finance.audit": "Finance Audit Trail",
    "settings.finance.workflows": "Finance Workflows",
    "settings.inventory.products": "Products",
    "settings.inventory.categories": "Categories",
    "settings.inventory.brands": "Brands",
    "settings.inventory.units": "Units",
    "settings.inventory.tax-rules": "Tax Rules",
    "settings.inventory.store-products": "Store Products",
    "settings.inventory.discounts": "Discounts",
    "settings.inventory.stock": "Stock Settings",
    "settings.inventory.stock-ledger": "Stock Ledger",
    "settings.inventory.warehouses": "Warehouses",
    "settings.crm.crm-setup": "CRM Setup",
    "settings.crm.lead-sources": "Lead Sources",
    "settings.crm.contacts": "Contacts",
    "settings.crm.crm-companies": "CRM Companies",
    "settings.crm.customers": "Customers",
    "settings.marketing.templates": "Marketing Templates",
    "settings.marketing.segments": "Audience Segments",
    "settings.marketing.suppression": "Consent & Suppression",
    "settings.marketing.webhooks": "Marketing Webhooks",
    "settings.marketing.acquisition": "Forms & Landing Pages",
    "settings.projects.project-setup": "Project Setup",
    "settings.projects.boards": "Boards",
    "settings.projects.issues": "Issues",
    "settings.projects.resources": "Resources",
    "settings.projects.automation": "Project Automation",
    "settings.help-desk.desk-setup": "Desk Setup",
    "settings.help-desk.workflows": "Desk Workflows",
    "settings.help-desk.canned-responses": "Canned Responses",
    "settings.help-desk.knowledge-base": "Knowledge Base",
    "settings.help-desk.boards": "Desk Boards",
    "settings.communication.social-connect": "Connection Center",
    "settings.communication.social-settings": "Social Settings",
    "settings.communication.social-webhooks": "Social Webhooks",
    "settings.workflow.finance-workflows": "Finance Workflow Builder",
    "settings.workflow.desk-workflows": "Desk Workflow Builder",
    "settings.workflow.project-automation": "Project Workflow Automation",
    "settings.approvals.approval-builder": "Approval Builder",
    "settings.approvals.approval-matrix": "Approval Matrix",
    "settings.approvals.delegations": "Approval Delegations",
    "settings.notifications.notification-center": "Notification Center",
    "settings.developer.api-keys": "API Keys",
    "settings.developer.lead-webhooks": "Lead Webhooks",
    "settings.developer.marketing-webhooks": "Marketing Webhooks",
    "settings.hr-master-data.leave-types": "Leave types",
    "settings.hr-master-data.employment-types": "Employment types",
    "settings.hr-master-data.document-types": "Document types",
    "settings.hr-master-data.business-units": "Business units",
    "settings.hr-master-data.departments": "Departments",
    "settings.hr-master-data.grades": "Grades",
    "settings.hr-master-data.designations": "Designations",
    "settings.hr-master-data.overtime-types": "Overtime types",
    "settings.hr-master-data.shift-types": "Shift types",
    "settings.hr-master-data.shift-definitions": "Shift definitions",
    "settings.hr-master-data.expense-types": "Expense types",
    "settings.hr-master-data.asset-types": "Asset types",
    "settings.hr-master-data.asset-requests": "Asset requests",
    "settings.hr-master-data.pipeline-stages": "Pipeline stages",
    "settings.hr-master-data.holiday-calendar": "Holiday calendar",
    "settings.hr-master-data.holiday-types": "Holiday types",
    "settings.hr-master-data.biometric-devices": "Biometric devices"
  },
  "modules": {
    "POS": "Point of Sale",
    "HR": "Human Resources",
    "FINANCE": "Finance",
    "CRM": "CRM",
    "DESK": "Customer Service",
    "PROCUREMENT": "Procurement",
    "WAREHOUSE": "Warehouse",
    "PROJECTS": "Projects",
    "SOCIAL": "Social Media",
    "MARKETING": "Marketing",
    "LEADGEN": "Lead Generation"
  },
  "breadcrumbModules": {
    "POS": "POS",
    "CRM": "CRM",
    "HR": "HR",
    "FINANCE": "Finance",
    "DESK": "Customer Service",
    "PROJECTS": "Projects",
    "PROCUREMENT": "Procurement",
    "WAREHOUSE": "Warehouse",
    "SOCIAL": "Social Media",
    "MARKETING": "Marketing",
    "LEADGEN": "Lead Generation"
  },
  "work": {
    "myWork": "My Work",
    "notifications": "Notifications",
    "approvalInbox": "Approval inbox",
    "executiveView": "Executive view",
    "approvalWorkflows": "Approval workflows",
    "workflowBuilder": "Workflow builder",
    "approvalMatrix": "Approval matrix",
    "delegations": "Approval delegations"
  },
  "sidebar": {
    "favorites": "Favorites",
    "recent": "Recent",
    "organization": "Organization"
  }
}
